import { LEARN_APP_STEPS } from '../../../constants/homeData';
import learnBg from '../../../assets/images/learnanytime-bg.png';
import learnLeft from '../../../assets/images/learnanytime-left.png';
import iconDownload from '../../../assets/images/learn-step-download.png';
import iconAccount from '../../../assets/images/learn-step-account.png';
import iconLearn from '../../../assets/images/learn-step-learn.png';

const STEP_ICONS = {
  download: iconDownload,
  user: iconAccount,
  book: iconLearn,
};

function StepIcon({ type }) {
  const src = STEP_ICONS[type];

  if (!src) return null;

  return (
    <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg `}>
      <img src={src} alt="" className="h-5 w-5 object-contain" />
    </span>
  );
}

function LearnAppSection() {
  const stepUi = {
    install: { w: 'w-full max-w-[340px] sm:w-[340px] lg:w-[300px] xl:w-[353px]', ml: 'lg:ml-8 xl:ml-16' },
    account: { w: 'w-full max-w-[320px] sm:w-[300px] lg:w-[280px] xl:w-[340px]', ml: 'lg:ml-16 xl:ml-44' },
    learn: { w: 'w-full max-w-[380px] sm:w-[380px] lg:w-[340px] xl:w-[392px]', ml: 'lg:ml-10 xl:ml-24' },
  };

  return (
    <section className="px-4 py-6 sm:px-6 sm:py-10 lg:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="relative min-h-[480px] overflow-hidden rounded-[28px] px-4 py-6 sm:px-8 lg:min-h-[510px] lg:px-10">
          <div
            className="absolute inset-0 bg-contain bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${learnBg})` }}
            aria-hidden
          />

          <div className="relative z-10 grid items-start gap-8 lg:grid-cols-[minmax(0,320px)_1fr] lg:gap-10 xl:grid-cols-[360px_1fr] xl:gap-14">
            <div className="mx-auto mt-6 w-full max-w-[280px] overflow-hidden rounded-[26px] lg:mx-0 lg:mt-10 lg:max-w-[300px] xl:max-w-[350px]">
              <img
                src={learnLeft}
                alt="Learn anytime"
                className="h-auto max-h-[320px] w-full object-contain lg:max-h-[380px] xl:h-[402px]"
              />
            </div>

            <div className="text-center lg:text-left">
              <h2 className="text-2xl font-bold text-[#FF9C07] lg:text-[28px] xl:text-[32px]">
                Learn Anytime ,Anywhere with
              </h2>
              <p className="mt-5 max-w-lg text-sm font-medium text-[#001640] sm:text-sm">
                Start your Learning Journey , Download our app and access anytime, anywhere - right from your phone .
              </p>

              <div className="mt-6 flex flex-col items-center gap-5 lg:items-start">
                {LEARN_APP_STEPS.map((step) => (
                  (() => {
                    const ui = stepUi[step.id] || {};
                    return (
                  <div
                    key={step.id}
                    className={`flex flex-col text-start ${ui.w || 'w-[340px] sm:w-[353px] lg:w-[380px]'} items-start gap-3 rounded-2xl px-5 py-4 text-white  ${step.bgClass} ${ui.ml || ''} ${step.offset || ''}`}
                  >
                    <div className='flex flex-row items-center gap-2'>
                    <StepIcon type={step.icon} boxClassName="bg-white/20" />
                      <p className="text-[20px] font-bold text-white">{step.title}</p>
                      </div>
                      <p className="text-xs text-[#D7D4D4] sm:text-[14px]">{step.description}</p>
                  </div>
                    );
                  })()
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LearnAppSection;
